// Account
export const SET_ACCOUNTS = 'SET_ACCOUNTS'
export const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT'

// WebSocket
export const SOCKET_CONNECTED = 'SOCKET_CONNECTED'
export const SOCKET_DISCONNECTED = 'SOCKET_DISCONNECTED'
export const SOCKET_LOADING = 'SOCKET_LOADING'
export const SOCKET_LOADED = 'SOCKET_LOADED'

// Window
export const WINDOW_STATE = 'WINDOW_STATE'
export const WINDOW_CREATE = 'WINDOW_CREATE'
export const WINDOW_DELETE = 'WINDOW_DELETE'
export const WINDOW_OPEN = 'WINDOW_OPEN'
export const WINDOW_CLOSE = 'WINDOW_CLOSE'
export const WINDOW_DATA = 'WINDOW_DATA'
export const WINDOW_TITLE = 'WINDOW_TITLE'

// Channel
export const CHANNEL_CLEAR = 'CHANNEL_CLEAR'
export const CHANNEL_STATE = 'UPDATE_CHANNEL'
export const OVERLAY_ADD = 'OVERLAY_ADD'
export const OVERLAY_REMOVE = 'OVERLAY_REMOVE'
export const OVERLAY_PLAY = 'OVERLAY_PLAY'
export const OVERLAY_STOP = 'OVERLAY_STOP'
export const OVERLAY_DATA = 'OVERLAY_DATA'
export const OVERLAY_OPTIONS = 'OVERLAY_OPTIONS'
export const OVERLAY_NEXT = 'OVERLAY_NEXT'
export const OVERLAY_INVOKE = 'OVERLAY_INVOKE'

// Templates
export const TEMPLATE_STATE = 'TEMPLATE_STATE'
export const TEMPLATE_CREATE = 'TEMPLATE_CREATE'
export const TEMPLATE_DELETE = 'TEMPLATE_DELETE'
export const TEMPLATE_FOLDER = 'TEMPLATE_FOLDER'
export const TEMPLATE_LAYER = 'TEMPLATE_LAYER'
export const TEMPLATE_NAME = 'TEMPLATE_NAME'
export const TEMPLATE_DATA = 'TEMPLATE_DATA'
export const TEMPLATE_OPTIONS = 'TEMPLATE_OPTIONS'
export const TEMPLATE_OVERLAY_DATA = 'TEMPLATE_OVERLAY_DATA'
export const TEMPLATE_OVERLAY_OPTIONS = 'TEMPLATE_OVERLAY_OPTIONS'

// Album
export const ALBUM_STATE = 'ALBUM_STATE'
export const ALBUM_CREATE = 'ALBUM_CREATE'
export const ALBUM_DELETE = 'ALBUM_DELETE'
export const ALBUM_META = 'ALBUM_META'
export const ALBUM_PICTURE_CREATE = 'ALBUM_PICTURE_CREATE'
export const ALBUM_PICTURE_UPDATE = 'ALBUM_PICTURE_UPDATE'
export const ALBUM_PICTURE_DELETE = 'ALBUM_PICTURE_DELETE'

// Dataset
export const DATASET_STATE = 'DATASET_STATE'
export const DATASET_CREATE = 'DATASET_CREATE'
export const DATASET_DELETE = 'DATASET_DELETE'
export const DATASET_UPDATE_META = 'DATASET_UPDATE_META'
export const DATASET_CREATE_RECORD = 'DATASET_CREATE_RECORD'
export const DATASET_DELETE_RECORD = 'DATASET_DELETE_RECORD'
export const DATASET_UPDATE_RECORD = 'DATASET_UPDATE_RECORD'
export const DATASET_UPDATE_RECORDS = 'DATASET_UPDATE_RECORDS'
export const DATASET_UPDATE_VALUE = 'DATASET_UPDATE_VALUE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js